"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../../components/theme");
exports.CSS = {
    container: 'c-ExportNotificationDetail',
    field: 'c-ExportNotificationDetail__Field',
    form: 'c-ExportNotificationDetail__Form',
    reason: 'c-ExportNotificationDetail__Reason',
    default: 'c-ExportNotificationDetail__Default'
};
exports.Style = {
    [exports.CSS.field]: {
        'font-weight': theme_1.DefaultTheme.font.weight.bold
    }
};
//# sourceMappingURL=export.notification.detail.style.js.map